document.addEventListener("candyrack-offer-added", (e) => {
  const previous = localStorage.getItem("candyrack-discounted-products") || "";
  const interval = setInterval(async () => {
    const current = localStorage.getItem("candyrack-discounted-products") || "";
    if (previous !== current) {
      clearInterval(interval);
      const cartResponse = await fetch("/cart.js");
      const cart = await cartResponse.json();
      document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
    }
  }, 50);

  setTimeout(() => {
    clearInterval(interval);
  }, 7000);
});
